(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 1400;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    /* Digits only — no whitespace in the numeric group, or the space between
       "100,000" and "Hitters" gets eaten and re-emitted as "100,000Hitters". */
    function parse(raw) {
      var match = raw.match(/^([^\d]*)(\d[\d.,]*\d|\d)([\s\S]*)$/);
      if (!match) return null;

      var numeric = match[2];
      var target = parseFloat(numeric.replace(/,/g, ''));
      if (!isFinite(target)) return null;

      var decimalMatch = numeric.match(/\.(\d+)$/);

      return {
        prefix: match[1],
        numeric: numeric,
        suffix: match[3],
        target: target,
        grouped: numeric.indexOf(',') !== -1,
        decimals: decimalMatch ? decimalMatch[1].length : 0
      };
    }

    /* Rebuilds the element so the digits sit in their own inline-block sized
       to the final value. Words stay in normal flow and cannot shift. */
    function build(el, parts) {
      var wrap = document.createElement('span');
      wrap.className = 'sp-badge__num';
      wrap.setAttribute('aria-hidden', 'true');

      var ghost = document.createElement('span');
      ghost.className = 'sp-badge__num-ghost';
      ghost.textContent = parts.numeric;

      var live = document.createElement('span');
      live.className = 'sp-badge__num-live';
      live.textContent = parts.numeric;

      wrap.appendChild(ghost);
      wrap.appendChild(live);

      var announced = document.createElement('span');
      announced.className = 'sp-visually-hidden';
      announced.textContent = parts.numeric;

      el.textContent = '';
      if (parts.prefix) el.appendChild(document.createTextNode(parts.prefix));
      el.appendChild(wrap);
      el.appendChild(announced);
      if (parts.suffix) el.appendChild(document.createTextNode(parts.suffix));

      return live;
    }

    function animate(live, parts) {
      function render(value) {
        live.textContent = parts.grouped
          ? value.toLocaleString(undefined, {
              minimumFractionDigits: parts.decimals,
              maximumFractionDigits: parts.decimals
            })
          : value.toFixed(parts.decimals);
      }

      var start = null;
      function step(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / DURATION, 1);
        render(parts.target * easeOutCubic(t));
        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          live.textContent = parts.numeric;
        }
      }

      render(0);
      requestAnimationFrame(step);
    }

    function init(root) {
      var scope = root || document;
      var nodes = scope.querySelectorAll('[data-sp-count]:not([data-sp-ready])');
      if (!nodes.length) return;

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      Array.prototype.forEach.call(nodes, function (el) {
        el.setAttribute('data-sp-ready', 'true');
        if (reduced || typeof IntersectionObserver === 'undefined') return;

        var raw = el.getAttribute('data-value') || el.textContent || '';
        var parts = parse(raw);
        if (!parts) return;

        var live = build(el, parts);

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              animate(live, parts);
            });
          },
          { threshold: 0.4 }
        );
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
